// extracted by mini-css-extract-plugin
module.exports = {"title":"auth-payment_title__2rGLy","error":"auth-payment_error__LL7N1","modal":"auth-payment_modal__1gD5I","buttons":"auth-payment_buttons__37iBL"};